export const removeEmptyValues = (values) => {
  for (let i in values) {
    if (values[i] === "") delete values[i];
  }
  return values;
};
